export enum tags {
  kesehatangigi = "#KesehatanGigi",
  dentalanak = "#DentalAnak",
  tipsperawatan = "#TipsPerawatan",
  csr = "#CSR",
}
